// LazyLoaderTrigger.js
import { useEffect } from "react";
import { useLoading } from "../../shared/Loader/LoadingContext";

const LazyLoaderTrigger = () => {
  const { setIsGlobalLoading } = useLoading();

  useEffect(() => {
    setIsGlobalLoading(true);

    return () => {
      setIsGlobalLoading(false);
    };
  }, []);

  return null;
};

export default LazyLoaderTrigger;